import { useEffect, useState } from 'react';
import type { Content, Location } from '@plone/types';
import { getRelatedLocations } from '../utils/getRelatedLocations';

export function useRelatedLocations(content?: Content) {
  const [locations, setLocations] = useState<Location[]>([]);

  useEffect(() => {
    const rel = getRelatedLocations(content);
    if (rel.length > 0) {
      setLocations(rel);
    }
  }, [content]);

  return { locations };
}
